import React from "react";
import { useSettingsData } from "../../../../contexts/SettingsDataContext";
import AnimatedBottomBanner from "./animated-bottom-banner";
import { usePathname } from "expo-router";
import { AlertCircle } from "lucide-react-native";
import { useViewport } from "../../../../hooks/useViewport";

const UnsavedChangesBanner = () => {
  const pathname = usePathname();
  const isSettingsPage = pathname.startsWith("/settings");
  const {
    hasUnsavedChanges,
    handleSaveChanges,
    handleDiscardChanges,
    isSaveLoading,
  } = useSettingsData();
  const { isMobile } = useViewport();
  if (!hasUnsavedChanges || !isSettingsPage) {
    return null;
  }

  return (
    <AnimatedBottomBanner
      visible={hasUnsavedChanges}
      icon={AlertCircle}
      message={isMobile ? "Unsaved changes" : "You have unsaved changes"}
      colorScheme="main"
      // position={isMobile ? "top" : "bottom"}
      position="bottom"
      buttons={[
        {
          text: "Discard",
          onPress: handleDiscardChanges,
          variant: "secondary",
          disabled: isSaveLoading,
        },
        {
          text: "Save",
          onPress: handleSaveChanges,
          variant: "primary",
          disabled: isSaveLoading,
          isLoading: isSaveLoading,
        },
      ]}
    />
  );
};

export default UnsavedChangesBanner;
